<template>
  <app-admin>
    <div class="container content clearfix">
      <h1>Добавление программ к группе {{group.name}}</h1>

      <table cellspacing="0" cellpadding="0" class="main-table">
        <thead>
        <tr>
          <th>№</th>
          <th>В группе</th>
          <th>Название программы</th>
          <th></th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(test, index) in tests" :key="test.id">
          <td style="width: 40px;">{{(itemsPerPage*(currentPage-1)) + index+1}}</td>
          <td style="width: 60px;" class="text-center">
            <font-awesome-icon icon="check" v-if="checkIfInGroup(test)" class="primary"/>
          </td>
          <td>
            {{test.name}}
          </td>
          <td>
            <div class="btn" v-show="!checkIfInGroup(test)" @click="addToGroup(test)">Добавить к группе</div>
            <div class="btn btn-light" v-show="checkIfInGroup(test)" @click="removeFromGroup(test)">Удалить из группы
            </div>
          </td>
        </tr>
        </tbody>
      </table>

      <pagination @change="setPage" :itemsPerPage="itemsPerPage" :resultCount="resultCount"/>

      <div class="buttons">
        <router-link :to="{name: 'Group', params: { id: group.id }}">
          <div class="btn btn-light">Назад к группе</div>
        </router-link>
      </div>
    </div>

  </app-admin>
</template>

<script>
  import GroupsService from '@/services/GroupsService'
  import TestsService from '@/services/TestsService'
  import Pagination from '@/components/Pagination'

  export default {
    name: 'GroupTests',
    components: {
      'pagination': Pagination
    },
    data () {
      return {
        filter: '',
        group: {
          name: '',
          theme: {
            name: ''
          }
        },
        tests: [],
        testsInGroup: [],
        showOnlyInGroup: false,
        currentPage: 1,
        itemsPerPage: 10,
        resultCount: 0
      }
    },
    methods: {
      setPage (pageNumber) {
        this.currentPage = pageNumber
        this.getPlayers()
      },
      checkIfInGroup (test) {
        return this.testsInGroup.filter(x => x.id === test.id).length > 0
      },
      removeFromGroup (test) {
        TestsService.removeTestFromGroup(this.group.id, test.id).then(
          (response) => {
            let index = this.testsInGroup.findIndex(x => x.id === test.id)
            this.testsInGroup.splice(index, 1)
          }
        )
      },
      addToGroup (test) {
        TestsService.addTestToGroup(this.group.id, test.id).then(
          (response) => {
            this.testsInGroup.push(test)
          }
        )
      },
      getTests () {
        TestsService.getTests(this.currentPage, this.itemsPerPage, this.filter).then(
          (response) => {
            this.tests = response.results
            this.resultCount = response.count
          },
          (error) => {
            console.log(error)
          }
        )
      }
    },
    computed: {},
    created () {
      let id = this.$route.params.id
      GroupsService.getGroup(id).then(
        (response) => {
          this.group = response
        },
        (error) => console.log(error)
      )

      TestsService.getTestsByGroupId(id).then(
        (response) => { this.testsInGroup = response },
        (error) => { console.log(error) }
      )

      this.getTests()
    }
  }
</script>

<style scoped lang="scss">
  table {
    td {
      padding-top: 5px !important;
      padding-bottom: 5px !important;;
    }
    .btn {
      text-align: center;
      padding: 10px 0px;
      box-sizing: border-box;
      width: 145px;
      font-size: 14px;
    }
  }

  .primary {
    color: $blue;
  }

  .content {
    padding-bottom: 50px;
  }

  .buttons {
    position: absolute;
    padding: 15px 20px;
    left: 0;
    bottom: 0;
  }
</style>



// WEBPACK FOOTER //
// src/pages/admin/groups/GroupTests.vue